import React from "react";

function MySkillsPage() {
  return <div>MySkillsPage</div>;
}

export default MySkillsPage;
